import React from 'react';
import {CreateGroupInput} from '../../graphql';
import {UniversalCard} from '../Cards/UniversalCard';
import {GroupForm} from '../Form/GroupForm';

interface GroupNewViewProps {
  createGroup: Function;
}

export const GroupNewView = ({createGroup}: GroupNewViewProps) => {
  return (
    <UniversalCard title="New Group">
      <GroupForm onSubmit={(values: CreateGroupInput) => createGroup(values)}/>
    </UniversalCard>
  );
};
